import { render, staticRenderFns } from "./AppPanel.vue?vue&type=template&id=708cfe9c&"
import script from "./AppPanel.vue?vue&type=script&lang=js&"
export * from "./AppPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports